module.exports = __webpack_public_path__ + "static/15-e21a71eeef8a15ad35f5ee3f60a4dced.png";